import { lazy, Suspense, useCallback, useState } from 'react';
import EventEmitter from '@utility/eventSubscribers';

const PrintPopup = lazy(() => import('@components/checkListV2/Modals/PrintPopup'));

export const usePrintModal = ({ row, serverAppTheme }) => {
  const [isPrintOpen, setIsPrintOpen] = useState(false);

  const onOpenPrint = useCallback(() => setIsPrintOpen(true), []);
  const onClosePrint = useCallback(() => setIsPrintOpen(false), []);

  const jsx = isPrintOpen ? (
    <Suspense fallback={null}>
      <PrintPopup
        isOpen={isPrintOpen}
        onClose={onClosePrint}
        row={row}
        serverAppTheme={serverAppTheme}
      />
    </Suspense>
  ) : null;

  return { onOpenPrint, jsx };
};

export const createPrintHandler = ({ onOpenPrint, onDirectPrint }) => {
  return () => {
    if (onOpenPrint) {
      onOpenPrint();
      return;
    }

    onDirectPrint?.();
  };
};

export const createDirectPrintHandler = ({
  data,
  deviceInfo,
  userInfo,
  printingAction,
  setErrorPopUp,
  setNotification,
  setPrintNotification,
}) => {
  return () => {
    const printData = {
      deviceId: deviceInfo.deviceId,
      employeeId: Number(userInfo.id),
      employeeCard: userInfo.employeeCard,
      storeId: deviceInfo.storeId,
      checkHeaderId: data?.id,
      seatIds: [],
    };

    printingAction(printData)
      .then(res => {
        if (window.ReactNativeWebView && !res?.printerAgentBased) {
          EventEmitter.print(res);
          EventEmitter.printData(
            payload => {
              if (payload?.type === 'error') {
                setNotification({ res: payload?.message });
              }
            },
            err => setErrorPopUp({ res: err?.message || err })
          );
        }
        setPrintNotification(res);
      })
      .catch(err => setErrorPopUp({ res: err?.message || err }));
  };
};
